import { gql } from '@apollo/client/core';

export const richTextBlockFragment = gql`
  fragment RichTextBlockFields on RichTextBlock {
    entryTitle
    richText {
      json
      __typename
    }
    __typename
  }
`;
